import { useEffect, useState } from "react"
import { TabPanel, TabView } from "primereact/tabview"
import { useParams } from "react-router-dom"
import { ToastContent, toast } from "react-toastify";
import { getUsersDataById } from "services/userService";
import FlagInfo from "components/users/FlagInfo"
import AddUpdateUsers from "components/users/AddUpdateUsers"
import { handleLoader, handleNotFound } from "redux/counterSlice";
import { useDispatch, useSelector } from "react-redux";

const AddUpdateUser = () => {
    const permissions = useSelector((state: any) => state.persistent.user_permissions);
    const params = useParams()
    const [userEmail, setUserEmail] = useState()
    const [data, setData] = useState<{ [s: string]: any }>({})
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(handleNotFound(false))
        if (params.id !== "add") {
            fetchUserData(params?.id?.toString() ?? "")
        }
    }, [])

    const fetchUserData = async (id: string) => {
        dispatch(handleLoader(true));
        try {
            const { result, error } = await getUsersDataById(id)
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            dispatch(handleLoader(false));
            setUserEmail(result.email)
            setData(result)
        } catch (error) {
            dispatch(handleLoader(false));
            toast.error(error as ToastContent<unknown>, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }

    return (
        <main className="content-wrapper p-4">
            <div className="user-group user-management-section">
                <h4 className="mb-3">
                    {params.id !== "add" ? "Edit User" : "Add User"}
                </h4>
                <div className="user-group-card">
                    <div className="user-group-body">
                        <div className="tabs-wrap">
                            {params.id === "add" ? (
                                <AddUpdateUsers {...{ firstName: data.firstName, lastName: data.LastName, email: data.email, add: permissions.add, edit: permissions.edit }} />
                            ) : (
                                <TabView>
                                    <TabPanel header="Details">
                                        <AddUpdateUsers {...{ firstName: data.firstName, lastName: data.lastName, email: data.email, add: permissions.add, edit: permissions.edit }} />
                                    </TabPanel>
                                    <TabPanel header="Flag Manage">
                                        <FlagInfo email={userEmail ?? ""} />
                                    </TabPanel>
                                </TabView>
                            )}

                        </div>
                    </div>
                </div>
            </div>
        </main >
    )
}

export default AddUpdateUser
